import Stream2 from './Stream2';

export default Stream2;
